module.exports = __webpack_public_path__ + "static/media/customer-prabhuji.e3663312.png";